<header class="app-header">
  <a href='/'><img style="width: 215px" src="/assets/images/FSX-logo.webp" alt="File and Serve Express Logo" /></a>
  <aside class="login-aside">
      <span>Already have an account?</span>
      <a class="button-link button-secondary" href="https://www.fileandservexpress.com/login/">Log in</a>
  </aside>
</header>
<main>
  <router-outlet></router-outlet>
</main>
<footer class="app-footer">
  <small class="footer-copy">&#169; {{ currentDate | date : 'yyyy' }} File & ServeXpress All rights reserved.</small>
  <nav class="footer-nav">
    <a href="https://www.fileandservexpress.com/about-us/" target="_blank">Company</a>
    <a href="https://secure.fileandservexpress.com/agreement.htm?v=20200905" target="_blank">Legal</a>
    <a href="https://www.fileandservexpress.com/privacy/" target="_blank">Privacy</a>
  </nav>
  <section class="fsx-links">
    <div><mat-icon class="footer-icon" svgIcon="icon-phone" /><a href="tel:8885297587">888 529 7587</a></div>
    <div><mat-icon class="footer-icon" svgIcon="icon-email" /><a href="email:support@fileandserve.com">support&#64;fileandserve.com</a></div>
    <div><mat-icon class="footer-icon" svgIcon="icon-chat" /><a href="javascript:void zE('messenger', 'open');">Chat</a></div>    
  </section>
</footer>